/**
 * ActionButton - 통합 액션 버튼 컴포넌트
 *
 * variant: 'primary' | 'secondary' | 'ghost' | 'danger'
 * size: 'sm' | 'md' | 'icon-only'
 */

import React from 'react';
import './ActionButton.css';

function ActionButton({
  children,
  onClick,
  variant = 'secondary',
  size = 'md',
  icon: Icon,
  disabled = false,
  title = "",
  className = "",
  type = "button"
}) {
  const classes = [
    'ui-action-btn',
    `ui-action-btn--${variant}`,
    `ui-action-btn--${size}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      className={classes}
      onClick={onClick}
      disabled={disabled}
      title={title}
      type={type}
    >
      {Icon && <Icon size={16} className="ui-action-btn__icon" />}
      {children && <span className="ui-action-btn__text">{children}</span>}
    </button>
  );
}

export default ActionButton;
